import React from 'react';
import { Model } from "@singularsystems/neo-core";
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import { Catalogue } from "@singularsystems/neo-react-services";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles";
import OrganisationInstrumentTypeLookup from '../../../Common/Models/OrganisationInstrumentTypeLookup';
import { AppService, Types } from '../../StaticData/StaticDataTypes';
import OrganisationInstrumentTypeSearchCriteria from '../../../Common/Models/OrganisationInstrumentTypeSearchCriteria';
import OrganisationInstrumentType from '../../../Common/Models/OrganisationInstrumentType';

export default class OrganisationInstrumentTypePagedCatalogueEntry extends Catalogue.PagedCatalogueEntry<OrganisationInstrumentTypeSearchCriteria, OrganisationInstrumentTypeLookup, OrganisationInstrumentType> {

    constructor(private apiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        private instrumentTypeApiClient = AppService.get(Types.ApiClients.InstrumentTypeApiClient),
        private taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super("Organisation Instrument Types", OrganisationInstrumentTypeSearchCriteria, OrganisationInstrumentTypeLookup, OrganisationInstrumentType, {
            sortBy: "organisationName",
            fetchInitial: true,
            pageSize: 10,
            pageSizeOptions: [10, 20, 50],
        });
    }

    public organisations = this.apiClient.getStaticOrganisationList().then((res) => {
        return res.data;
    });

    public staticInstrumentTypes = this.instrumentTypeApiClient.getInstrumentTypeListFromCriteria("").then((res) => {
        return res.data;
    });

    public get editRole() {
        return Roles.OrganisationConfigurationsRoles.Edit;
    }

    public getPagedDataEndpoint() {
        return this.apiClient.getOrganisationInstrumentTypes;
    }

    public getSaveEndpoint() {
        return this.apiClient.saveOrganisationInstrumentType;
    }

    public renderCriteria(criteria: OrganisationInstrumentTypeSearchCriteria, meta: Model.TransformMetaType<OrganisationInstrumentTypeSearchCriteria>) {
        return (
            <Neo.GridLayout lg={3}>
                <Neo.FormGroup label="Organisation Name" bind={meta.organisationName} />
                <Neo.FormGroup label="Instrument Type Name" bind={meta.instrumentTypeName} />
            </Neo.GridLayout>
        )
    }

    public renderRow(item: OrganisationInstrumentTypeLookup, meta: Model.TransformMetaType<OrganisationInstrumentTypeLookup>) {
        return (
            <NeoGrid.RowGroup>
                <NeoGrid.Row>
                    <NeoGrid.Column display={meta.organisationName} />
                    <NeoGrid.Column display={meta.staticInstrumentTypeName} />
                    <NeoGrid.ButtonColumn deleteButton={{ onClick: () => this.removeItem(this.taskRunner, item) }} />
                </NeoGrid.Row>
            </NeoGrid.RowGroup>
        );
    }

    public renderFormControls(item: OrganisationInstrumentType, meta: Model.TransformMetaType<OrganisationInstrumentType>) {
        return (
            <div>
                <Neo.GridLayout md={3}>
                    <Neo.FormGroup
                        bind={meta.organisationId}
                        select={{ items: this.organisations, displayMember: "organisationName", valueMember: "organisationId" }} />
                    <Neo.FormGroup
                        bind={meta.staticInstrumentTypeId}
                        select={{ items: this.staticInstrumentTypes, displayMember: "staticInstrumentTypeName", valueMember: "staticInstrumentTypeId" }} />
                </Neo.GridLayout>
            </div>
        );
    }
}